import React from 'react';
import useAppID from '../hooks/useAppId';
import useReceivePaste from '../hooks/useReceivePaste';
import useClippy from 'use-clippy'
import useClipboard from '../hooks/useClipboard';


export default function Paste() {

    const ID = useAppID();

    // const [clipboard, setClipboard] = useClippy();

    const { paste } = useReceivePaste(ID!);

    const clipboard = useClipboard();

    const content = paste?.content?.replace(/\n/g, "<br />");


    return (
        <>
            <pre style={{whiteSpace: 'pre-line', textAlign: 'left'}} dangerouslySetInnerHTML={{__html: content ?? 'No remote clipboard yet!'}}></pre>
            <pre style={{whiteSpace: 'pre-line'}}>clipboard content: {clipboard}</pre>
        </>
    )
}